import React, { Component } from 'react';


export default class ElectionBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameCode: "500",
      tvShow: true,
      tvUrl: ""
    };
  }
  componentDidMount() {
    setInterval(() => { this.setState({}) }, 1000)
  }
  formatDate(date) {
    if (!date) {
      return ""
    }
    date = new Date(date)
    let month = [];
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sept";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    let mn = date.getMonth() + 1;
    mn = mn > 9 ? mn : "0" + mn
    let dt = date.getDate();
    dt = dt > 9 ? dt : "0" + dt
    let hr = date.getHours();
    hr = hr > 9 ? hr : "0" + hr
    let min = date.getMinutes();
    min = min > 9 ? min : "0" + min
    let year = date.getFullYear()
    let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
    return formatedDate

  }

  render() {

    return (
      <div className=" live-match">
        <div className="sub_path center-box crname mb-2">
          <p>
            {!!this.props.game && !!this.props.game.event && !!this.props.game.competition && <><span>{!!this.props.game && !!this.props.game.event["name"] ? this.props.game.event["name"] : null} - {!!this.props.game && !!this.props.game.competition["name"] ? this.props.game.competition["name"] : null}</span> <span className="f-right">{this.formatDate(this.props.game.event["openDate"])}</span></>}
          </p>
        </div>
        <div className="livetv mt-1">
          {!!this.props.tvUrl && this.props.tvUrl !== "" && <>
            <div className="sub_path center-box crname">
              <p>
                <span>Live TV</span>
                <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onClick={() => { this.props.onOffTv() }}>
                  <input type="checkbox" className="custom-control-input" checked={this.props.tvShow} />
                  <label className="custom-control-label" for="customSwitches"></label>
                </div>
              </p>
            </div>
            <div className="game-wrap col3 mb-0 pb-0">
              {this.props.tvShow && <div className="mobiletviframe">
                {!this.props.isNoBalence ? <iframe title={"iframe"} key={"iframe"} id='fp_embed_player' src={this.props.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe> :
                  <div className='no-balence'>You Don't have enough balance to watch Live TV.</div>
                }
              </div>}</div>
          </>
          }
        </div>
      </div>
    )
  }
}
